/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {getSnackBarToast} from '../../../../../util/snackBar'
import moment from 'moment'
import {getAvailabilityEmployabilityExcelService} from '../../../services/ratio.service'
import {FormProvider, useForm} from 'react-hook-form'
import {ReportOccupancyModel} from '../../../models/reports.model'
import {yupResolver} from '@hookform/resolvers/yup'
import {SelectOption} from '../../../../../models/utility.model'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {Select} from '../../../../../components/UI/Select'

const RatiosAvailability: FC = () => {
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])

  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const methods = useForm<ReportOccupancyModel>({
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
    },
  })
  const {
    control,
    formState: {errors},
    setValue,
    handleSubmit,
    setError,
    reset,
  } = methods

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})

      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleExportXLS = async (data: ReportOccupancyModel) => {
    try {
      setIsDownloadXLS(true)
      const response = await getAvailabilityEmployabilityExcelService(data)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Disponibilidad-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  const onSubmit = (data: ReportOccupancyModel) => {
    handleExportXLS(data)
  }

  const handleClear = () => {
    reset()
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setCamp([{value: '', label: 'TODOS'}])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
  }

  return (
    <KTCard shadow className='m-5'>
      <div className='pt-6 ps-6'>
        <FormProvider {...methods}>
          <form className='m-2'>
            <div className='row'>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Compañía:</label>
                <Select
                  control={control}
                  name='CompaniaId'
                  data={compani}
                  errors={errors}
                  onChangeValue={handleFilterClient}
                />
              </div>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Cliente:</label>
                <Select
                  control={control}
                  name='ClienteId'
                  data={client}
                  errors={errors}
                  onChangeValue={handleFilterSite}
                />
              </div>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Site:</label>
                <Select
                  control={control}
                  name='SiteId'
                  data={site}
                  errors={errors}
                  onChangeValue={handleFilterCamp}
                />
              </div>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Campamento:</label>
                <Select control={control} name='CampamentoId' data={camp} errors={errors} />
              </div>
            </div>
          </form>
          <div className='row'>
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button
                onClick={handleSubmit(onSubmit)}
                label='Descargar Disponibilidad'
                disabled={isDownloadXLS}
                loading={isDownloadXLS}
              />
              <Button label='Limpiar' onClick={handleClear} />
            </ButtonWrapper>
          </div>
        </FormProvider>
      </div>
    </KTCard>
  )
}

export {RatiosAvailability}
